export const CONTENT_TYPES = {
  INCOMING_EMAIL: 'incoming_email',
  // 卡片消息
  CARD: 'cs_card',
  // 评价卡片
  CSAT: 'input_csat',
};
